var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 140,
    viewBox: "0 0 140 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 140C108.66 140 140 108.66 140 70C140 31.3401 108.66 0 70 0C31.3401 0 0 31.3401 0 70C0 108.66 31.3401 140 70 140Z",
    fill: "currentColor"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    id: "g1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.7508 53.6474C90.5045 52.2571 88.1422 52.4063 86.7442 53.8557L64.2125 76.7217L53.3953 65.2771C51.6339 63.4429 50.1039 62.9474 48.4196 64.4011C46.7362 65.854 47.355 68.0329 48.699 69.5397L61.7148 84.1317C62.397 84.8971 63.3039 85.2829 64.2125 85.2829C65.0748 85.2829 65.937 84.9349 66.6125 84.2389L91.3668 58.6043C92.7639 57.1574 92.9979 55.0386 91.7508 53.6474Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.780ea432.svg";
export { ForwardRef as ReactComponent };